import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PaymentFailIcon from "../../assets/images/paymentFailIcon.png";
import CustomButton from "../../components/CustomButton";
import { Routes } from "../../navigation/navigation-types";

const PaymentFail = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img
        style={{ marginTop: 144 }}
        src={PaymentFailIcon}
        alt='success icon'
        height={190}
        width={275}
      />
      <Typography
        style={{
          fontSize: 28,
          color: theme.palette.main.alert.o,
          fontWeight: "700",
          marginTop: 50,
          marginBottom: 10,
        }}
      >
        {t("paymentRejected.title")}
      </Typography>
      <Typography
        style={{
          fontSize: 16,
          fontWeight: "400",
          color: theme.palette.natural.t,
          marginBottom: 36,
        }}
      >
        {t("paymentRejected.description")}
      </Typography>
      <CustomButton
        title={t("paymentRejected.continue")}
        size='large'
        style={{ width: 140 }}
        onClick={() =>
          navigate(`${Routes.profile}`, {
            state: { preselectedTab: "subscription" },
          })
        }
      />
    </Box>
  );
};

export default PaymentFail;
